import { StorageKeys } from "../services/constants";
import { env } from "../services/env";

// Matches an email to a regex expression, returns true if expression is invalid
export const emailValidation = (emailToValidate: string): boolean => {
  return (
    /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/.test(
      emailToValidate
    ) === false
  );
};

export const currentEnv = () => {
  if (process.env.REACT_APP_ENVIRONMENT !== "production") {
    let environment = localStorage.getItem(StorageKeys.ENV);
    if (environment !== null) {
      return environment;
    }
  }
  if (env === undefined) {
    throw new Error("Environment not defined");
  }
  return `${env}`.replace("https://", "").replace(".appspot.com", "");
};

export function arraysAreEqual<T>(array1: T[], array2: T[]) {
  if (array1.length === array2.length) {
    return [...array1].sort().join(",") === [...array2].sort().join(",");
  }
  return false;
}

export const currentVer = () => {
  let version = localStorage.getItem(StorageKeys.VERSION);
  if (version !== null) {
    return version;
  }
  return "";
};
